import { CodeBase } from "./_codeBase";

/** 設問区分*/
export class QuestionDiv extends CodeBase<QuestionDiv>
{
    /** 設問区分: "01", "テキスト（文章）"*/
    public static readonly TEXT: QuestionDiv = new QuestionDiv("01", "テキスト（文章）", "");
    /** 設問区分: "02", "テキスト（数値）"*/
    public static readonly NUMBER: QuestionDiv = new QuestionDiv("02", "テキスト（数値）", "");
    /** 設問区分: "03", "ラジオボタン"*/
    public static readonly RADIO: QuestionDiv = new QuestionDiv("03", "ラジオボタン", "");
    /** 設問区分: "04", "チェックボックス"*/
    public static readonly CHECKBOX: QuestionDiv = new QuestionDiv("04", "チェックボックス", "");
    /** 設問区分: "05", "リストボックス"*/
    public static readonly LISTBOX: QuestionDiv = new QuestionDiv("05", "リストボックス", "");
    /** 設問区分: "06", "時刻"*/
    public static readonly TIME: QuestionDiv = new QuestionDiv("06", "時刻", "");
    ///** 設問区分: "07", "日付"*/
    //public static readonly DATE: QuestionDiv = new QuestionDiv("07", "日付", "");


    /**
    * 
    * @param value
    * @param text
    */
    protected constructor(code: any, value: string, abbr?: any) {
        super(code, value, abbr);
    }

    /**
     * 
     */
    public static List(): QuestionDiv[] {
        return [
            QuestionDiv.TEXT,
            QuestionDiv.NUMBER,
            QuestionDiv.RADIO,
            QuestionDiv.CHECKBOX,
            QuestionDiv.LISTBOX,
            QuestionDiv.TIME,
            //QuestionDiv.DATE,
        ];
    }
}
